import {Condition} from "../engine/Condition";
import {isString, toArray} from "../../../../stem-core/base/Utils";
import {merchantFunctionModule} from "../../merchant-state/MerchantFunctionModule";
import {loadReferrerUrl} from "../../../utils/Referrer";
import {getCurrentPath, isPathEqual} from "../../../utils/PageAccessHelpers.js";


export function testPath(
    path: string,
    include?: string | string[],
    exclude?: string | string[],
    oneOf?: string | string[],
    filterFunction?: string | any[],
): boolean {
    if (!path || !isString(path)) {
        return false;
    }
    const includeRE = toArray(include || ".*").map(str => RegExp(`^${str}$`));
    const excludeRE = toArray(exclude).map(str => RegExp(`^${str}$`));
    if (excludeRE.find(re => re.test(path) || re.test(path + "/")) != null) {
        return false;
    }
    if (includeRE.find(re => re.test(path) || re.test(path + "/")) == null) {
        return false;
    }
    if (oneOf != null) {
        oneOf = toArray(oneOf);
        if (!oneOf.find((targetPath) => targetPath && isPathEqual(targetPath, path))) {
            return false;
        }
    }
    if (filterFunction != null) {
        const [success, result] = merchantFunctionModule.call(filterFunction, path);
        if (!success || !result) {
            return false;
        }
    }
    return true;
}


export interface PathOptions {
    includePattern?: string | string[];
    excludePattern?: string | string[];
    oneOf?: string | string[];
    filterFunction?: string | any[];
}

export class PathCondition extends Condition<PathOptions> {
    evaluate() {
        return testPath(getCurrentPath(), this.options.includePattern, this.options.excludePattern, this.options.oneOf, this.options.filterFunction);
    }
}

export class ReferrerCondition extends Condition<PathOptions> {
    evaluate() {
        return testPath(loadReferrerUrl(), this.options.includePattern, this.options.excludePattern, this.options.oneOf, this.options.filterFunction);
    }
}
